<ng-container *ngIf="vm$ | async as vm">
  <section class="title-wrapper">
    <h4>
      {{
        'MMR.APPOINTMENTS_HISTORY.TITLE' + (serviceIncluded ? '_SERVICE' : '')
          | translate
      }}
    </h4>
    <p *ngIf="!appointmentsHistoryPanels?.length">
      {{ 'MMR.APPOINTMENTS_HISTORY.EMPTY' | translate }}
    </p>
  </section>
  <dgx-components-accordion
    *ngIf="appointmentsHistoryPanels.length > 0; else NoHistory"
    [panels]="vm.limitedPanels"
    class="appointments-history-accordion"
  >
    <ng-template
      #accordionPanelHeaderTemplate
      let-expanded="expanded"
      let-panel="panel"
    >
      <span
        [ngClass]="{ 'expanded-panel': expanded }"
        class="appointments-history-panel__header"
      >
        <div class="appointment-date">
          {{ panel.date | date : 'd MMMM yyyy' }}
        </div>
        <span class="appointment-title">
          {{ panel.title }}
        </span>
        <dgx-components-icon
          [name]="expanded ? 'chevron-up' : 'chevron-down'"
          size="lg"
          class="appointments-history-panel__header-icon"
        />
      </span>
    </ng-template>
    <ng-template
      #accordionPanelContentTemplate
      let-expanded="expanded"
      let-panel="panel"
    >
      <div class="appointments-history-panel__body">
        <div
          *ngFor="let panelItem of panel.body; trackBy: trackByIndex"
          class="appointments-history-panel__body-item"
        >
          <div class="appointment-date">
            {{ panelItem?.bodyDate | date : 'd MMMM yyyy' }}
          </div>
          <div class="accordion-panel-header__title">
            {{ panelItem?.bodyTitle }}
          </div>
        </div>
      </div>
    </ng-template>
  </dgx-components-accordion>
  <ng-template #NoHistory>
    <section class="empty-history__wrapper">
      <section class="empty-history">
        <dgx-components-icon
          [name]="'circle-dashed'"
          size="lg"
          class="empty-history__icon"
        ></dgx-components-icon>
        <p>{{ 'MMR.APPOINTMENTS_HISTORY.NO_BOOKINGS' | translate }}</p>
      </section>
    </section>
  </ng-template>
  <button
    tabindex="0"
    role="presentation"
    *ngIf="vm.moreOptionsAvailable || showAll"
    (click)="showMoreToggle()"
    class="show-more-dates"
  >
    <p class="show-more-dates-text">
      {{
        showAll
          ? ('MMR.APPOINTMENTS_HISTORY.SHOW_LESS' | translate)
          : ('MMR.APPOINTMENTS_HISTORY.SHOW_MORE' | translate)
      }}
    </p>
    <dgx-components-icon
      [name]="showAll ? 'chevron-up' : 'chevron-down'"
      size="md"
      class="show-more-dates__icon"
    ></dgx-components-icon>
  </button>
</ng-container>
